import { makeStyles } from "@material-ui/core/styles";

export const useAddressesStyles = makeStyles((theme) => ({
  formControl: {
    width: "100%",
    textAlign: "start",
  },
  imageContainer: {
    marginTop: 10,
  },
  images: {
    maxWidth: 100,
  },
  enabledTextColor: {
    color: theme.palette.success.dark,
  },
  disabledTextColor: {
    color: theme.palette.grey[700],
  },
  reusableAddressesSelect: {
    width: "100%",
  },
}));
